var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#007f90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.90235 12.501C6.9029 12.7767 7.12659 13 7.40235 13H8.57201C8.84815 13 9.07201 12.7761 9.07201 12.5V7.5C9.07201 7.22386 8.84815 7 8.57201 7H7.39238C7.11585 7 6.89183 7.22446 6.89238 7.501L6.90235 12.501ZM8.74077 3.22471C8.52151 3.0782 8.26372 3 8.00001 3C7.64639 3 7.30725 3.14048 7.0572 3.39052C6.80715 3.64057 6.66668 3.97971 6.66668 4.33333C6.66668 4.59704 6.74488 4.85483 6.89138 5.07409C7.03789 5.29336 7.24613 5.46426 7.48977 5.56517C7.7334 5.66609 8.00149 5.69249 8.26013 5.64105C8.51877 5.5896 8.75635 5.46261 8.94282 5.27614C9.12929 5.08967 9.25628 4.8521 9.30772 4.59345C9.35917 4.33481 9.33277 4.06672 9.23185 3.82309C9.13093 3.57945 8.96004 3.37122 8.74077 3.22471Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.663887bac4a2cfb2f2a421d061750b6e.svg";
export { ForwardRef as ReactComponent };